import React from 'react'
import parse from 'html-react-parser'
import { loaderMap } from '@mortgage-pos/ui/utils/customizationHelpers'

const LoadingWithContent = ({ title, body }) => (
  <div className="content-loading" data-testid="loading-with-content">
    <img
      className="content-loading__gif"
      src={loaderMap('default')}
      alt="loading icon"
    />

    <div className="content-loading__text">
      <h2 className="content-loading__title">{parse(title)}</h2>
      <p className="content-loading__description">{parse(body)}</p>
    </div>
  </div>
)

export default LoadingWithContent
